import React, {useState, useEffect} from 'react';
import QuestionRenderer from './QuestionRenderer';

const KnowledgeCheckPhase = ({question, questionIndex, totalQuestions, kcAnswers, onSubmit, onNext}) => {
  const [submitted, setSubmitted] = useState(false);
  const [isCorrect, setIsCorrect] = useState(null);

  useEffect(() => {
    setSubmitted(false);
    setIsCorrect(null);
  }, [questionIndex]);

  const handleSubmit = (selectedAnswer) => {
    const correct = selectedAnswer === question.correctAnswer;
    setIsCorrect(correct);
    setSubmitted(true);
    onSubmit(selectedAnswer);
  };

  return (
    <div className="lcv-check-panel">
      <div className="lcv-check-header">
        <span className="lcv-check-badge">KNOWLEDGE CHECK</span>
        <span className="lcv-check-count">Question {questionIndex + 1} of {totalQuestions}</span>
      </div>

      <QuestionRenderer
        question={question}
        onSubmit={handleSubmit}
        showFeedback={submitted}
        isCorrect={isCorrect}
      />

      {submitted && (
        <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: 16}}>
          <button className="lcv-btn-primary" onClick={onNext}>
            {questionIndex + 1 < totalQuestions ? 'Next Question' : 'See Results'}
          </button>
        </div>
      )}
    </div>
  );
};

export default KnowledgeCheckPhase;
